import { faCalendarCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Spinner } from "@blueprintjs/core";
import { INTENT_PRIMARY } from '@blueprintjs/core/lib/esm/common/classes';
import moment from 'moment-timezone';
import React from 'react';
import { SHORT_DATE_TIME_FORMAT_24 } from '../../../utils/Constants';
import { getDistanceMatrix } from '../../services/googleApiService';
import { calendarCheckIcon, fontWeightBold, keyEventsTable, tripDetailTableDiv } from '../../styles';

const tripEventsTemplate = [
    { 'event': 'Confirmed', 'time': null, 'distance': 'N/A' },
    { 'event': 'Accepted', 'time': null, 'distance': '' },
    { 'event': 'Onsite', 'time': null, 'distance': '' },
    { 'event': 'Onboard', 'time': null, 'distance': '' },
    { 'event': 'NoLoad', 'time': null, 'distance': '' },
    { 'event': 'Complete', 'time': null, 'distance': '' }
]
export default class KeyEventsTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tripEvents: tripEventsTemplate,
        }
    }

    getDistance = async (actualCoordinates, destCoordinates) => {
        try {
            const data = await getDistanceMatrix(actualCoordinates, destCoordinates);
            if (data.rows.length > 0) {
                const element = data.rows[0].elements[0];
                if (element.status === "OK") {
                    return element.distance.text;
                }
                else {
                    return 'N/A'
                }
            } else {
                return 'N/A'
            }
        }
        catch (error) {
            console.log(error);
            return 'N/A'
        }
    }

    componentDidMount() {
        if (this.props.trip?.tripNumber) {
            this.setTripEvents();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.trip?.tripNumber && this.props.trip?.tripNumber !== prevProps.trip?.tripNumber) {
            this.setTripEvents();
        }
    }

    setTripEvents = async () => {
        const trip = this.props.trip;

        const tripEvents = [
            {
                'event': 'Confirmed',
                'time': trip?.confirmEventTime ? moment.tz(trip.confirmEventTime, trip.pickupTimeZone).format(`${SHORT_DATE_TIME_FORMAT_24} z`) : '',
                'distance': 'N/A'
            },
            {
                'event': 'Accepted',
                'time': trip?.acceptEventTime ? moment.tz(trip.acceptEventTime, trip.pickupTimeZone).format(`${SHORT_DATE_TIME_FORMAT_24} z`) : '',
                'distance': ''
            },
            {
                'event': 'Onsite',
                'time': trip?.onsiteEventTime ? moment.tz(trip.onsiteEventTime, trip.pickupTimeZone).format(`${SHORT_DATE_TIME_FORMAT_24} z`) : '',
                'distance': ''
            },
            {
                'event': 'Onboard',
                'time': trip?.pickupEventTime ? moment.tz(trip.pickupEventTime, trip.pickupTimeZone).format(`${SHORT_DATE_TIME_FORMAT_24} z`) : '',
                'distance': ''
            },
            {
                'event': 'NoLoad',
                'time': trip?.noShowEventTime ? moment.tz(trip.noShowEventTime, trip.pickupTimeZone).format(`${SHORT_DATE_TIME_FORMAT_24} z`) : '',
                'distance': ''
            },
            {
                'event': 'Complete',
                'time': trip?.dropoffEventTime ? moment.tz(trip.dropoffEventTime, trip.pickupTimeZone).format(`${SHORT_DATE_TIME_FORMAT_24} z`) : '',
                'distance': ''
            },
        ];

        const promises = [];

        if (trip.acceptEventTime !== null && trip.acceptEventLat !== 0 && trip.acceptEventLon !== 0 && trip.pickupLat !== 0 && trip.pickupLon !== 0) {
            const p1 = this.getDistance(
                { lat: trip.acceptEventLat, lon: trip.acceptEventLon },
                { lat: trip.pickupLat, lon: trip.pickupLon }).then(distance => { tripEvents[1].distance = distance });
            promises.push(p1);
        }

        if (trip.onsiteEventTime !== null && trip.onsiteEventLat !== 0 && trip.onsiteEventLon !== 0 && trip.pickupLat !== 0 && trip.pickupLon !== 0) {
            const p2 = this.getDistance({ lat: trip.onsiteEventLat, lon: trip.onsiteEventLon },
                { lat: trip.pickupLat, lon: trip.pickupLon }).then(distance => { tripEvents[2].distance = distance });
            promises.push(p2);
        }

        if (trip.pickupEventTime !== null && trip.pickupEventLat !== 0 && trip.pickupEventLon !== 0 && trip.dropoffLat !== 0 && trip.dropoffLon !== 0) {
            const p3 = this.getDistance({ lat: trip.pickupEventLat, lon: trip.pickupEventLon },
                { lat: trip.dropoffLat, lon: trip.dropoffLon }).then(distance => { tripEvents[3].distance = distance });
            promises.push(p3);
        }

        if (trip.dropoffEventTime !== null && trip.dropoffEventLat !== 0 && trip.dropoffEventLon !== 0 && trip.dropoffLat !== 0 && trip.dropoffLon !== 0) {
            const p4 = this.getDistance(
                { lat: trip.dropoffEventLat, lon: trip.dropoffEventLon },
                { lat: trip.dropoffLat, lon: trip.dropoffLon }).then(distance => { tripEvents[4].distance = distance });
            promises.push(p4);
        }

        await Promise.all(promises);

        await this.setState({
            tripEvents: tripEvents,
        })

        this.props.handleLoading();
    }

    render() {
        return (
            <div style={tripDetailTableDiv}>
                <div style={{ display: 'flex', alignIitems: 'self-end' }}>
                    <span style={calendarCheckIcon}><FontAwesomeIcon icon={faCalendarCheck} /> Key Events</span>
                    {this.props.isLoading &&
                        <div style={{ marginLeft: '5px' }}>
                            <Spinner
                                className={INTENT_PRIMARY}
                                size={Spinner.SIZE_SMALL} />
                        </div>}
                </div>

                <table id="key-events-table" style={keyEventsTable}>
                    <thead style={fontWeightBold}>
                        <tr>
                            <td></td>
                            <td>Time</td>
                            <td>Distance</td>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.isLoading ?
                            tripEventsTemplate.map(tripEvent => {
                                return (
                                    <tr key={tripEvent.event}>
                                        <td>{tripEvent.event}</td>
                                        <td>{tripEvent.time}</td>
                                        <td>{tripEvent.distance}</td>
                                    </tr>

                                );
                            }) :

                            this.state.tripEvents.map(tripEvent => {
                                return (
                                    <tr key={tripEvent.event}>
                                        <td>{tripEvent.event}</td>
                                        <td>{tripEvent.time}</td>
                                        <td>{tripEvent.distance}</td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>
            </div>
        )
    }
}
